import React, { useState } from 'react';
import './SubscriptionForm.css';

const SubscriptionForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const [showPaymentOptions, setShowPaymentOptions] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Show payment options
    setShowPaymentOptions(true);
  };

  return (
    <div className="subscription-form-overlay">
      <div className="subscription-form-container">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Subscribe</h2>
        {showPaymentOptions ? (
          <div className="payment-options">
            <h3>Select Payment Method</h3>
            <button className="payment-button">Credit Card</button>
            <button className="payment-button">PayPal</button>
            <button className="payment-button">Bank Transfer</button>
            <button className="close-button" onClick={onClose}>Close</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input type="phone" name="phone" value={formData.phone} onChange={handleChange} required />
            </div>
            <button type="submit" className="submit-button">Next</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default SubscriptionForm;
